module.exports = __webpack_public_path__ + "img/phone.c02ff7df.svg";